import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Artigo from "../pages/artigo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guia/:slug",
    element: <Artigo />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;